<script>
export default {
	data: () => {
		return {
			copyrightDate: new Date().getFullYear(),
			projectName: 'Vue.js & Tailwind CSS Portfolio',
			author: 'Stoman',
		};
	},
};
</script>

<template>
	<div class="flex justify-center items-center text-center">
		<div
			class="font-general-regular text-lg text-ternary-dark dark:text-ternary-light"
		>
		Don't see a project listed? 
			<a
				href="https://github.com/dappslist/zksync-dapps-list/issues/1"
				target="__blank"
				class="underline hover:text-indigo-600 dark:hover:text-indigo-300 duration-500"
			>
				Write a comment here
			</a>.
			
			<br />
			<br />

			&copy; {{ copyrightDate }} by 
			<a
				href="https://dappslist.net"
				target="__blank"
				class="font-general-medium hover:underline hover:text-indigo-600 dark:hover:text-indigo-300 duration-500"
			>
				Dapps List</a>. (<a
				href="https://github.com/realstoman/vuejs-tailwindcss-portfolio"
				target="__blank"
				class="font-general-medium hover:underline hover:text-indigo-600 dark:hover:text-indigo-300 duration-500"
			>Theme
			</a>
			by
			<a
				href="https://stoman.me"
				target="__blank"
				class="font-general-medium text-secondary-dark dark:text-secondary-light uppercase hover:underline hover:text-indigo-600 dark:hover:text-indigo-300 duration-500"
				>{{ author }}</a
			>)
		</div>
	</div>
</template>

<style lang="scss" scoped></style>
